import { render, staticRenderFns } from "./emptyLayout.vue?vue&type=template&id=aa0254c4&"
import script from "./emptyLayout.vue?vue&type=script&lang=js&"
export * from "./emptyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports